(function () {
    'use strict';
    var controllerId = 'cndPartecipDtlEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'common', '_', 'datacontext', 'partecipazione', 'tAziende', 'isSuper', fn_cndPartecipDtlEdit]);

    function fn_cndPartecipDtlEdit($scope, $uibModalInstance, common, _, datacontext, partecipazione, tAziende, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.record = jQuery.extend({}, partecipazione);
        $scope.tAziende = tAziende;
        $scope.isSuper = isSuper;
        $scope.record.FAM1_TAziendaId = null;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = editItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function editItem(item) {
            return datacontext.partecipazione_merge(item).then(function (data) {
                return data;
            });
        }

        $scope.changeTAzienda = function () {
            $scope.record.Foro = null;
        };
    }
})();